import { AppButton, AppTextDifference } from 'components';
import DOMPurify from 'dompurify';
import { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import * as AppPics from 'assets/images';
import useTopics from 'hooks/API/GET/useTopics';
import useQueryParams from 'hooks/useQueryParams';
import useDebounce from 'hooks/useDebounce';
import { getRandomUid } from 'utilities/uuid.service';
// import TextReviewModal from './TextReviewModal';
// import CommentReviewModal from './CommentReviewModal';
import useManageTopicNotes from 'hooks/API/useManageTopicNotes';
import DetailsHeader from 'components/molecules/DetailsHeader';
import useManageTopicGeek from 'hooks/API/useManageTopicGeek';
import CommentDropBox from './CommentDropBox';
import useOnClickOutside from 'hooks/useOnClickOutside';
import SelectionBlock from './SelectionBlock';
import { COMMENT_IDENTIFIER, ROLES } from 'utilities/constants';
import CommentHistory from './CommentHistory';
import { FaCommentDots } from 'react-icons/fa';
import { UserContext } from 'context/UserContext';
import { notifier } from 'components/Toaster';
import TopicRatingHistory from '../TopicRatingHistory';
import { typesetMath, unwrapMathFromPre } from 'utilities/mathjax.service';

function Clicker(node) {
  const __floatingBubble = document.getElementById('floating-selection-bubble');
  const __CommentDropBoxModal = document.getElementById('CommentDropBoxModal');
  const __editorBackdrop = document.getElementsByClassName(
    'cke_reset_all cke_dialog_container cke_1 cke_editor_editor1_dialog cke_hidpi'
  );
  const cke_dialog_body = document.getElementsByClassName('cke_dialog_body');
  const cke_dialog_contents = document.getElementsByClassName('cke_dialog_contents');
  const comment_side_modal = document.getElementById('CommentDropBoxModal');
  const cke_dialog_ui_labeled_content = document.getElementsByClassName(
    'cke_dialog_ui_labeled_content'
  );
  const cke_dialog_ui_input_text = document.getElementsByClassName('cke_dialog_ui_input_text');
  const cke_dialog_ui_hbox = document.getElementsByClassName('cke_dialog_ui_hbox');
  const __isClickInsideCommentModal =
    (__CommentDropBoxModal && __CommentDropBoxModal.contains(node)) || false;
  const __isClickInsideCommentBubble =
    (__floatingBubble && __floatingBubble.contains(node)) || false;

  const res =
    !__isClickInsideCommentModal &&
    !__isClickInsideCommentBubble &&
    !cke_dialog_body &&
    !cke_dialog_ui_labeled_content &&
    !cke_dialog_ui_input_text &&
    !cke_dialog_ui_hbox &&
    !comment_side_modal &&
    !cke_dialog_contents &&
    !__editorBackdrop[0]?.contains?.(node); // this done to prevent closing of comment modal while closing image dialog box of CKEDITOR 4

  return {
    isOutSideClick: res,
  };
}

function PreviewSection({ forCommentHistory, turnOnCommenting = false }) {
  const [tab, setTab] = useState('preview');

  const [blocks, setBlocks] = useState([]);
  const [prereviousBlocks, setPreviousBlocks] = useState([]);
  const [isPreview, setISPreview] = useState(false);
  const [selectedText, setSelectedText] = useState('');
  const [commentsModal, setCommentsModal] = useState(Object.assign({}, _initialState));
  const [replyModal, setReplyModal] = useState({ open: false, apiHash: null });
  const [orginalText, setOrginalText] = useState('');
  const [previousText, setPreviousText] = useState('');

  const { userInfo = {} } = useContext(UserContext);
  const isSE = userInfo?.data?.key === ROLES.SUBJECT_EXPERT;

  useEffect(() => {
    if (forCommentHistory) {
      setTab('cHistory');
    }
  }, [forCommentHistory]);

  useEffect(() => {
    if (blocks) {
      const node = document.querySelector('#MATH-CONTENT-AREA');
      typesetMath(node);
    }
  }, [blocks]);
  const ref = useRef();
  useOnClickOutside(ref, (event) => {
    const element = document.getElementsByClassName('___Marker');
    const __floatingBubble = document.getElementById('floating-selection-bubble');
    const __clicker = Clicker(event.target);

    if (__clicker.isOutSideClick) {
      if (commentsModal.open) setCommentsModal(Object.assign({}, _initialState));

      for (let index = 0; index < element.length; index++) {
        if (element[index]) {
          const __data = element[index].innerHTML;
          element[index].replaceWith(__data);
        }
      }
    }

    // if (__floatingBubble && !__floatingBubble.contains(event.target))
    //   __floatingBubble.style.display = 'none';
  });

  const { classID, courseID, chapterID, topicID } = useParams();
  const query = useQueryParams();
  const subtopicID = query.get('subtopic');
  const lessonType = query.get('lessonType');
  const replyCommentHash = query.get('replyCommentHash');

  useEffect(() => {
    if (replyCommentHash) {
      setReplyModal({
        open: true,
        apiHash: replyCommentHash,
      });
    }
  }, [replyCommentHash]);

  const __params = { classID, courseID, chapterID, topicID };
  const { data } = useTopics({
    ...__params,
    enabled: true,
    configs: { params: { subtopicID, commentPage: true } },
  });
  const { mutate, isLoading } = useManageTopicNotes({ topicID });
  const { mutate: geekMutate, isLoading: geekLoading } = useManageTopicGeek({
    topicID,
    axiosConfigs: {
      params: { subtopicID },
    },
  });

  const textForMarking = useDebounce(selectedText, 1000);

  useEffect(() => {
    if (data?.data?.notes?.[0]?.blocks && lessonType === 'notes')
      setBlocks(data?.data?.notes[0]?.blocks?.map((x) => ({ ...x, id: x._id })));
    if (data?.data?.geekcorner?.[0]?.blocks && lessonType === 'geek_corner')
      setBlocks(data?.data?.geekcorner[0]?.blocks?.map((x) => ({ ...x, id: x._id })));
    if (data?.data?.notes?.[0]?.previousBlock && lessonType === 'notes')
      setPreviousBlocks(data?.data?.notes[0]?.previousBlock?.map((x) => ({ ...x, id: x._id })));
    if (data?.data?.geekcorner?.[0]?.previousBlock && lessonType === 'geek_corner')
      setPreviousBlocks(
        data?.data?.geekcorner[0]?.previousBlock?.map((x) => ({ ...x, id: x._id }))
      );
  }, [data?.data, lessonType]);

  useEffect(() => {
    if (textForMarking && turnOnCommenting && tab === 'preview') {
      wrapSelection(textForMarking);
    }
    return () => {};
  }, [textForMarking]);

  function handleSelection(e) {
    if (isSE) return;

    const text = document.getSelection().toString();
    if (text) {
      setSelectedText(text);
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function removeExistingSelections() {
    if (replyModal.open) setReplyModal({ open: false, apiHash: null });

    const __markers = document.getElementsByClassName('___Marker');
    const __floatingBubble = document.getElementById('floating-selection-bubble');
    for (let i = 0; i < __markers.length; i += 1) {
      const __parent = document.getElementById('MATH-CONTENT-AREA');
      const ___abc = __parent.contains(__markers[i]);
      if (___abc) {
        // __markers[i].replaceWith(__markers[i].innerHTML); //have issue like showing strings

        // // Create the new element -- this works
        // const newElement = document.createElement('span');
        // newElement.innerHTML = __markers[i].innerHTML;

        // // Replace the old element with the new one
        // __markers[i].parentNode.replaceChild(newElement, __markers[i]);
        // -- this works

        const children = Array.from(__markers[i].childNodes);
        __markers[i].replaceWith(...children);
      }
    }

    if (__floatingBubble) __floatingBubble.style.display = 'none';
  }

  function checkIfCommentExists(container) {
    let commentExists = false;

    if (container) {
      const childNodes = container.childNodes;
      for (let index = 0; index < childNodes.length; index++) {
        const __classList = childNodes[index].classList;
        commentExists = __classList ? [...__classList].includes(COMMENT_IDENTIFIER) : false;
        if (commentExists) break;
      }
    }

    return commentExists;
  }

  function checkSelectionCriteria() {
    const wSelection = document.getSelection();
    const range = wSelection.getRangeAt(0);

    let startNode = range.startContainer;
    let endNode = range.endContainer;

    // Get common ancestor node
    const commonAncestor = range.commonAncestorContainer;

    // Traverse up the DOM tree from startNode to find the first parent
    while (startNode && startNode.nodeType !== Node.ELEMENT_NODE) {
      startNode = startNode.parentNode;
    }

    // Traverse up the DOM tree from endNode to find the first parent
    while (endNode && endNode.nodeType !== Node.ELEMENT_NODE) {
      endNode = endNode.parentNode;
    }

    // Check if both startNode and endNode are paragraphs and have the same parent
    if (startNode && endNode && startNode === endNode) {
      console.log('Selected lines have the same parent.');
      return true;
    } else {
      notifier.warn('Please select texts belonging to one paragraph at a time.');

      // Clear the selection to avoid visual disturbance
      wSelection.removeAllRanges();
      console.log('Selected lines do not have the same parent.');
      return false;
    }
  }

  function wrapSelection() {
    const wSelection = document.getSelection();

    if (wSelection.rangeCount && checkSelectionCriteria()) {
      const masterArea = document.getElementById('MATH-CONTENT-AREA');
      if (masterArea && !masterArea.contains(wSelection.anchorNode.parentElement)) return;
      const __CommentDropBoxModal = document.getElementById('CommentDropBoxModal');

      // this is done to avoid deselection when image (after upload) is selected
      if (__CommentDropBoxModal && !__CommentDropBoxModal.contains(wSelection.anchorNode)) {
        removeExistingSelections();
      } else if (__CommentDropBoxModal === null) {
        // if not from comment modal; then remove any other selection made before this wrapping new text
        removeExistingSelections();
      }

      const container = document.createElement('div');
      const __cloneContents = wSelection.getRangeAt(0).cloneContents();
      container.appendChild(__cloneContents);

      let commentExists = checkIfCommentExists(container);
      if (commentExists) {
        wSelection.removeAllRanges();
        return;
      }

      const __parent = wSelection.anchorNode.parentElement.closest('.__AppContentBlocks__');

      if (masterArea && !masterArea.contains(__parent)) return;

      wSelection.getRangeAt(0).insertNode(container);

      let _blockId;
      if (__parent) {
        _blockId = __parent.getAttribute('data-block-id');
      }
      const __span = document.createElement('span');
      const __spanID = getRandomUid();
      __span.setAttribute('class', '___Marker');
      __span.setAttribute('data-id', __spanID);
      __span.setAttribute('id', __spanID);
      const __object = {
        open: true,
        modal_id: __spanID,
        dataBlockId: _blockId,
        selectedCommentText: DOMPurify.sanitize(container.innerHTML),
      };
      // __span.onclick = () => {
      //   setCommentsModal(__object);
      // };
      __span.innerHTML = container.innerHTML;

      wSelection.getRangeAt(0).deleteContents();
      container.replaceWith(__span);
      wSelection.getRangeAt(0).insertNode(__span);

      // const rect = wSelection.getRangeAt(0).getBoundingClientRect();
      const rect = __span.getBoundingClientRect();
      const __floatingBubble = document.getElementById('floating-selection-bubble');

      // console.log(' rect.left -- ', rect);
      if (__floatingBubble) {
        // __floatingBubble.style.display = 'none';
        __floatingBubble.style.top = `calc(${rect.top}px - 48px + ${window.scrollY}px)`;
        __floatingBubble.style.left = `calc(${rect.left}px + calc(${rect.width}px / 2) - 40px)`;
        __floatingBubble.style.display = 'block';
        __floatingBubble.setAttribute('data-json-id', JSON.stringify(__object));
      }

      wSelection.removeAllRanges();
    }
  }

  useEffect(() => {
    function handleClick(event) {
      const apiHash = event.target.getAttribute('data-api-hash');
      // before reply modal opens; remove existing selections made, if any;
      removeExistingSelections();

      // before reply modal opens; close comment modal, if opened;
      if (commentsModal.open) {
        setCommentsModal(Object.assign({}, _initialState));
      }

      setReplyModal({ open: true, apiHash });
    }

    const __html = document.querySelectorAll(`[data-api-hash]`);

    for (let index = 0; index < __html.length; index++) {
      const element = __html[index];
      element.addEventListener('click', handleClick);
    }
    return () => {
      for (let index = 0; index < __html.length; index++) {
        const element = __html[index];
        element.removeEventListener('click', handleClick);
      }
    };
  }, [blocks, commentsModal.open, removeExistingSelections]);

  useEffect(() => {
    document.addEventListener('selectionchange', handleSelection);
    return () => {
      document.removeEventListener('selectionchange', handleSelection);
    };
  }, []);

  function handleGeekSave(args = {}) {
    if (geekLoading) return;

    const geekID = data?.data?.geekcorner[0]?._id;
    const plans = data?.data?.geekcorner[0]?.plans;

    const apiBody = {
      // status,
      title: 'Geek corner',
      geekID,
      id: geekID,
      _id: geekID,
      plans,
      ...args,
    };

    geekMutate({ geekcorner: [apiBody], type: geekID ? 'UPDATE' : 'CREATE' });
  }

  function handleSave(args = {}) {
    if (lessonType === 'geek_corner') {
      handleGeekSave(args);
      return;
    }
    if (isLoading) return;

    const noteID = data?.data?.notes[0]?._id || data?.data?.notes[0]?.id;
    const plans = data?.data?.notes[0]?.plans;

    const apiData = {
      title: 'Notes',
      _id: noteID,
      noteID,
      plans,
      ...args,
    };

    mutate({
      notes: [apiData],
      subtopicID,
      type: noteID ? 'UPDATE' : 'CREATE',
      noactivity: args.noactivity,
      noMetaChanges: true,
    });
  }
  function showCompare(showPrevious) {
    if (showPrevious) {
      const orginal_content = document.getElementsByClassName('orginal-content');
      const previous_content = document.getElementsByClassName('previous-content');
      let orginal_content_ary = [];
      let previous_content_ary = [];
      for (let index = 0; index < orginal_content.length; index++) {
        orginal_content_ary.push(orginal_content[index].textContent);
      }
      for (let index = 0; index < previous_content.length; index++) {
        previous_content_ary.push(previous_content[index].textContent);
      }

      setOrginalText(orginal_content_ary.join('  '));
      setPreviousText(previous_content_ary.join('  '));
      setISPreview(true);
    } else {
      setISPreview(false);
    }
  }

  const __linkParams = { lessonType: 'notes' }; // conditonallty set notes or geek
  if (subtopicID) __linkParams.subtopic = subtopicID;

  return (
    <>
      <SelectionBlock fns={{ setCommentsModal, removeExistingSelections }} />
      <div className="mainWraper">
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <Link
                to={`/classes/${classID}/courses/${courseID}/chapters/${chapterID}/topics/${topicID}?${new URLSearchParams(
                  __linkParams
                ).toString()}`}
              >
                <AppButton variantClass="btn-back">
                  <img src={AppPics.BackSvg} alt="" />
                </AppButton>
              </Link>
            </li>
            {!forCommentHistory && (
              <li
                className={`${tab === 'preview' ? 'active' : ''}`}
                onClick={() => setTab('preview')}
              >
                Preview
              </li>
            )}
            <li
              className={`${tab === 'cHistory' ? 'active' : ''}`}
              onClick={() => setTab('cHistory')}
            >
              History
            </li>
            <li
              className={`${tab === 'cRating' ? 'active' : ''}`}
              onClick={() => setTab('cRating')}
            >
              Rating
            </li>
          </ul>
          {/* Compare Button */}

          {!forCommentHistory && tab === 'preview' && (
            <div className="tab__content ___adjust___tab___padding">
              {(replyModal.open || commentsModal.open) && (
                <CommentDropBox
                  open={replyModal.open || commentsModal.open}
                  close={() => {
                    setCommentsModal(Object.assign({}, _initialState));
                    setReplyModal({ open: false, apiHash: null });
                  }}
                  data={{
                    modalId: commentsModal.modal_id,
                    dataBlockId: commentsModal.dataBlockId,
                    commentText: commentsModal.selectedCommentText,
                    block: commentsModal.block,
                    replyModal,
                    apiBodyProps: {
                      lessonType,
                      commentText: commentsModal.selectedCommentText,
                      resolved: false,
                      class: classID,
                      course: courseID,
                      chapter: chapterID,
                      topic: topicID,
                      subtopic: subtopicID,
                    },
                  }}
                  updateBlock={(blockId, value, extras = {}) => {
                    const {
                      commentBlockHash,
                      removeBlockHas = false,
                      noactivity = false,
                    } = extras || {};
                    const newBlocks = blocks.map((block) => {
                      if (block._id === blockId) block.value = value;
                      if (block._id === blockId && commentBlockHash && !removeBlockHas)
                        block.commentBlockHash = commentBlockHash;
                      if (block._id === blockId && removeBlockHas) delete block.commentBlockHash;

                      return block;
                    });

                    handleSave({ blocks: newBlocks, noactivity });
                  }}
                />
              )}

              <div className="tab__content-actHead">
                <DetailsHeader />
              </div>
              <div className="">
                {/* {!isPreview && (
                <AppButton
                  variantClass="btn-right-content upload float-right m-3"
                  onClick={() => {
                    showCompare(true);
                  }}
                >
                  Compare 
                </AppButton>
              )} */}
                {isPreview && (
                  <AppButton
                    variantClass="btn-right-content upload float-right m-3"
                    onClick={() => {
                      showCompare(false);
                    }}
                  >
                    Back
                  </AppButton>
                )}
              </div>
              {!isPreview && (
                <div
                  className="row Texteditorsection relative __noMin__hgt __noborder __selection__area__"
                  id="MATH-CONTENT-AREA"
                  ref={ref}
                >
                  {blocks.map((block) => {
                    return (
                      <Fragment key={block.id}>
                        <div className="orginal-content">
                          {['text', 'problem', 'tip', 'box'].includes(block.currentBlock) && (
                            <div className="col-12 add_comment___area">
                              <div
                                data-block-id={block._id}
                                className="__AppContentBlocks__"
                                dangerouslySetInnerHTML={{
                                  __html: unwrapMathFromPre(DOMPurify.sanitize(block.value)),
                                }}
                              />
                            </div>
                          )}
                          {block.currentBlock === 'image' && (
                            <div className="__image_tool ___blockTools blue__light__border flex-p flex-column jc-center ai-center">
                              <button
                                onClick={() => {
                                  if (block?.commentBlockHash) {
                                    setReplyModal({
                                      open: true,
                                      apiHash: block.commentBlockHash,
                                    });
                                    return;
                                  }
                                  const _obj = {
                                    dataBlockId: block._id,
                                    modal_id: null,
                                    open: true,
                                    selectedCommentText: null,
                                    block,
                                  };
                                  setReplyModal({ open: false, apiHash: null });
                                  setCommentsModal({ open: true, ..._obj });
                                }}
                                className="____open__comments__"
                              >
                                {' '}
                                <FaCommentDots />
                              </button>
                              <div className="ratio ratio-21x9">
                                <img src={block.assetUrl} alt="presentational block content" />
                              </div>
                            </div>
                          )}
                          {block.currentBlock === 'video' && (
                            <div className="__video_tool ___blockTools blue__light__border flex-p flex-column jc-center ai-center">
                              <button
                                onClick={() => {
                                  if (block?.commentBlockHash) {
                                    setReplyModal({ open: true, apiHash: block.commentBlockHash });
                                    return;
                                  }
                                  const _obj = {
                                    dataBlockId: block._id,
                                    modal_id: null,
                                    open: true,
                                    selectedCommentText: null,
                                    block,
                                  };
                                  setReplyModal({ open: false, apiHash: null });
                                  setCommentsModal({ open: true, ..._obj });
                                }}
                                className="____open__comments__"
                              >
                                {' '}
                                <FaCommentDots />
                              </button>
                              <div className="ratio ratio-21x9">
                                <video width="320" height="240" controls>
                                  <source src={block.assetUrl} />
                                  Your browser does not support the video tag.
                                </video>
                              </div>
                            </div>
                          )}
                          {block.currentBlock === 'audio' && (
                            <div className="__audio_tool ___blockTools blue__light__border flex-p flex-column jc-center ai-center">
                              <button
                                onClick={() => {
                                  if (block?.commentBlockHash) {
                                    setReplyModal({ open: true, apiHash: block.commentBlockHash });
                                    return;
                                  }
                                  const _obj = {
                                    dataBlockId: block._id,
                                    modal_id: null,
                                    open: true,
                                    selectedCommentText: null,
                                    block,
                                  };
                                  setReplyModal({ open: false, apiHash: null });
                                  setCommentsModal({ open: true, ..._obj });
                                }}
                                className="____open__comments__"
                              >
                                {' '}
                                <FaCommentDots />
                              </button>
                              <div className="ratio ratio-21x9">
                                <audio controls>
                                  <source src={block.assetUrl} />
                                  Your browser does not support the audio tag.
                                </audio>
                              </div>
                            </div>
                          )}
                          {block.currentBlock === 'file' && (
                            <div className="__file_tool ___blockTools blue__light__border flex-p flex-column jc-center ai-center">
                              <button
                                onClick={() => {
                                  if (block?.commentBlockHash) {
                                    setReplyModal({ open: true, apiHash: block.commentBlockHash });
                                    return;
                                  }
                                  const _obj = {
                                    dataBlockId: block._id,
                                    modal_id: null,
                                    open: true,
                                    selectedCommentText: null,
                                    block,
                                  };
                                  setReplyModal({ open: false, apiHash: null });
                                  setCommentsModal({ open: true, ..._obj });
                                }}
                                className="____open__comments__"
                              >
                                {' '}
                                <FaCommentDots />
                              </button>
                              <div className="card border-dark mb-3" style={{ width: '18rem' }}>
                                <a href={block.assetUrl} target="_blank" rel="noopener noreferrer">
                                  <img src={AppPics.FileSvg} className="card-img-top" alt="" />
                                  <p className="h6 text-center my-2">Click to open in a new tab</p>
                                </a>
                              </div>
                            </div>
                          )}
                          {block.currentBlock === 'equation' && (
                            <div className="__file_tool ___blockTools blue__light__border flex-p flex-column jc-center ai-center">
                              <button
                                onClick={() => {
                                  if (block?.commentBlockHash) {
                                    setReplyModal({ open: true, apiHash: block.commentBlockHash });
                                    return;
                                  }
                                  const _obj = {
                                    dataBlockId: block._id,
                                    modal_id: null,
                                    open: true,
                                    selectedCommentText: null,
                                    block,
                                  };
                                  setReplyModal({ open: false, apiHash: null });
                                  setCommentsModal({ open: true, ..._obj });
                                }}
                                className="____open__comments__"
                              >
                                {' '}
                                <FaCommentDots />
                              </button>
                              <div className="__equation_tool col-12">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: unwrapMathFromPre(DOMPurify.sanitize(block.value)),
                                  }}
                                ></div>
                              </div>
                            </div>
                          )}
                        </div>
                      </Fragment>
                    );
                  })}
                  {true === false &&
                    prereviousBlocks.map((block) => {
                      return (
                        //for now, lets dont show this
                        <Fragment key={block.id}>
                          <div className="previous-content">
                            {['text', 'problem', 'tip', 'box'].includes(block.currentBlock) && (
                              <div className="col-12 add_comment___area">
                                <div
                                  data-block-id={block._id}
                                  className="__AppContentBlocks__"
                                  dangerouslySetInnerHTML={{
                                    __html: unwrapMathFromPre(DOMPurify.sanitize(block.value)),
                                  }}
                                />
                              </div>
                            )}
                            {block.currentBlock === 'image' && (
                              <div className="__image_tool ___blockTools blue__light__border flex-p flex-column jc-center ai-center">
                                <div className="ratio ratio-21x9">
                                  <img src={block.assetUrl} alt="presentational block content" />
                                </div>
                              </div>
                            )}
                            {block.currentBlock === 'video' && (
                              <div className="__video_tool ___blockTools blue__light__border flex-p flex-column jc-center ai-center">
                                <div className="ratio ratio-21x9">
                                  <video width="320" height="240" controls>
                                    <source src={block.assetUrl} />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              </div>
                            )}
                            {block.currentBlock === 'audio' && (
                              <div className="__audio_tool ___blockTools blue__light__border flex-p flex-column jc-center ai-center">
                                <div className="ratio ratio-21x9">
                                  <audio controls>
                                    <source src={block.assetUrl} />
                                    Your browser does not support the audio tag.
                                  </audio>
                                </div>
                              </div>
                            )}
                            {block.currentBlock === 'file' && (
                              <div className="__file_tool ___blockTools blue__light__border flex-p flex-column jc-center ai-center">
                                <div className="card border-dark mb-3" style={{ width: '18rem' }}>
                                  <a
                                    href={block.assetUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img src={AppPics.FileSvg} className="card-img-top" alt="" />
                                    <p className="h6 text-center my-2">
                                      Click to open in a new tab
                                    </p>
                                  </a>
                                </div>
                              </div>
                            )}
                            {block.currentBlock === 'equation' && (
                              <div className="__equation_tool col-12">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: unwrapMathFromPre(DOMPurify.sanitize(block.value)),
                                  }}
                                ></div>
                              </div>
                            )}
                          </div>
                        </Fragment>
                      );
                    })}
                </div>
              )}
              {isPreview && (
                <AppTextDifference
                  sourceText={orginalText}
                  newText={previousText}
                ></AppTextDifference>
              )}
            </div>
          )}
          {tab === 'cHistory' && (
            <div className="tab__content ___adjust___tab___padding">
              <div className="tab__content-actHead">
                <DetailsHeader />
              </div>
              <div className="tab__contentBody">
                <CommentHistory />
              </div>
            </div>
          )}
          {tab === 'cRating' && (
            <div className="tab__content ___adjust___tab___padding">
              <div className="tab__content-actHead">
                <DetailsHeader />
              </div>
              <div className="tab__contentBody">
                <TopicRatingHistory data={data?.data} />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const _initialState = {
  open: false,
  modal_id: null,
  dataBlockId: null,
  selectedCommentText: '',
};

export default PreviewSection;
